export default {
  route: {
    invalidUrl: 'この URL は有効なプロジェクトを指していません。',
    notFound: 'このジオメトリは存在しないか、アクセス権がありません。',
  },
} as const;
